import React from 'react';
import { Currency, useBalance } from '../Context/BalanceProvider';
import { useNavigate } from '../ProtectedRoute';
import LoadingIcon from './LoadingIcon';

export const CoinsPill: React.FC = () => {
  const { getBalance, isLoadingBalances } = useBalance();
  const navigate = useNavigate();

  return (
    <div
      className="min-w-8 h-9 max-sm:h-7 p-2 cursor-pointer bg-yellow-100 rounded-full border border-yellow-500/opacity-20 justify-start items-center gap-1.5 inline-flex"
      onClick={() => navigate('/redeem-rewards')}
    >
      {isLoadingBalances ? (
        <div className="h-full flex items-center justify-center">
          <LoadingIcon size={4} color="yellow-600" />
        </div>
      ) : (
        <>
          <div className="w-4 h-4 relative">
            <img
              loading="lazy"
              src={require('../assets/icons/coins.png')}
              alt="Coins"
              className="shrink-0 self-start w-4 aspect-square"
            />
          </div>
          <div className="text-center text-yellow-600 text-base font-bold">
            {getBalance(Currency.COINS)}
          </div>
        </>
      )}
    </div>
  );
};
